// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';        

// slick
import $ from 'jquery';
import '../third/jquery.slick';

export default class SlickSlider extends WebComponent {
  didMount() {
    const slider = $('.slick-slider');
    const isGallery = this.element.classList.contains('photogallery-slider');

    setTimeout(() => {
      if (isGallery) {
        // page gallery
        $(this.element).slick({
          // ... 
        });
      } else {
        // default
        $(this.element).slick({
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          appendDots: $('.hp-slider__dots'),
          autoplay: true,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          draggable: true,
          variableWidth: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                adaptiveHeight: false,
              },
            },
          ],
        });
      }

    }, 50);

    $(window).on('resize', function() {
      $(this.element).slick('resize');
    });

    $('[data-slick-reinit]').on('click', function() {		
      let tData = $(this).data('slickReinit');
      $(tData).slick('reinit');
    });
}
}



// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/components/SlickSlider.js